import { Icon, IconKey } from '@/shared/components';
import { useId } from 'react';
import { Field, FieldDescription, FieldError, FieldLabel } from '../ui/field';
import { InputGroup, InputGroupAddon, InputGroupInput } from '../ui/input-group';

interface FieldDateInputProps {
  id?: string;
  value?: string;
  label: string;
  description?: string;
  errors?: Array<{ message?: string } | undefined>;
  required?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
  onValueChange: (value: string) => void;
}

export function FieldDateInput({
  id,
  value,
  label,
  description,
  errors,
  required = false,
  disabled = false,
  min,
  max,
  onValueChange
}: FieldDateInputProps) {
  const internalId = useId();
  const inputId = id ?? internalId;

  return (
    <Field data-invalid={errors?.some((e) => e?.message) ? 'true' : required && !value ? 'true' : undefined}>
      <FieldLabel htmlFor={inputId} className='gap-1'>
        {label} {required && <span className='text-destructive'>*</span>}
      </FieldLabel>

      <InputGroup>
        <InputGroupInput
          id={inputId}
          type='date'
          value={value}
          disabled={disabled}
          required={required}
          min={min}
          max={max}
          onChange={(e) => onValueChange(e.target.value)}
          className='[&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-date-and-time-value]:text-left'
          aria-invalid={required && !value ? 'true' : undefined}
        />
        <InputGroupAddon align='inline-end' className='pointer-events-none'>
          <Icon icon={IconKey.Calendar} size={16} />
        </InputGroupAddon>
      </InputGroup>

      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldError errors={errors} />
    </Field>
  );
}
